import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class GroupService extends Service {
	constructor(injector: Injector) {
		super("Groups", injector);
	}
}